// @flow

import { apiWebsocketUrl } from "./api-url";
// FIXME: not sure why ESLint can't resolve this import. The code works fine.
import { Socket } from "phoenix"; // eslint-disable-line import/no-unresolved

import type { Channel } from "phoenix";

var socket;
var channels: { [string]: Channel } = {};

type Callback = (Error) => void;
type VoidCallback = () => void;
type MessageHandler = (any) => void;
type MessageHandlerMap = { [string]: MessageHandler };
type SocketParams = {
  token: ?string,
  white_label_site: string
};

export function disconnect(callback: VoidCallback) {
  if (socket) {
    var s = socket;
    channels = {};
    socket = undefined;
    s.disconnect(callback);
  } else {
    callback();
  }
}

export function connect(params: SocketParams, onOpen: VoidCallback, onClose: VoidCallback, onError: Callback) {
  if (socket) {
    console.error("already connected");
    return;
  }
  var s = new Socket(apiWebsocketUrl("/socket"), {
    params
    // logger: (kind, msg, data) => { console.log(`${ kind } : ${ JSON.stringify(msg) }`, data); }
  });
  s.onOpen(onOpen);
  s.onClose(onClose);
  s.onError(onError);
  s.connect();
  socket = s;
}

export function join(topic: string, ok: ?MessageHandler, err: ?Callback, messageHandlers: ?MessageHandlerMap): Channel {
  if (socket === undefined) {
    throw "Socket not connected";
  }
  if (channels[topic] === undefined) {
    channels[topic] = socket.channel(topic, {});
    if (messageHandlers) {
      registerMessageHandlers(channels[topic], messageHandlers);
    }
    channels[topic].join();

    if (typeof ok === "function") {
      channels[topic].joinPush.receive("ok", ok);
    }

    if (typeof err !== "function") {
      err = (joinErr) => console.error("Error joining", topic, "-", joinErr);
    }
    channels[topic].joinPush.receive("error", err);
  }
  return channels[topic];
}

function registerMessageHandlers(channel, messageHandlers) {
  Object.keys(messageHandlers).forEach((messageType) => {
    channel.on(messageType, messageHandlers[messageType]);
  });
}
